import { Card } from '@/ui/card'
import { useI18n } from '@/i18n/i18n-context'

/**
 * The one screen every unusable-link condition renders — a challenge 410, a verify 410 (whether the
 * grant was already dead or this was merely a wrong date of birth: verify's response cannot tell
 * the two apart, and neither can this screen), or three local wrong-date attempts. One component,
 * one message, so there is exactly one place in the codebase that could invent a distinction the
 * API does not make, and it does not (D-8).
 */
export function DeadLinkScreen() {
  const { t } = useI18n()
  return (
    <Card className="flex flex-col gap-2 text-center">
      <h1 className="text-lg font-semibold text-slate-900">{t('linkDead')}</h1>
      <p className="text-sm text-slate-600">{t('linkDeadDetail')}</p>
    </Card>
  )
}
